import script from "./edit-delta.vue?vue&type=script&lang=jsx"
export * from "./edit-delta.vue?vue&type=script&lang=jsx"

import "./edit-delta.vue?vue&type=style&index=0&id=5b302c7e&lang=scss"

const __exports__ = script;

export default __exports__